module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/22-96e21a54b838609b4a5a78484a415175.jpg";